/**
 * Jours fériés et jours ouvrés en France métropolitaine.
 *
 * UNE ÉCHÉANCE NE TOMBE PAS UN DIMANCHE. Les calendriers fiscaux publient des
 * dates déjà décalées au jour ouvré suivant ; pour les années que
 * l'administration n'a pas encore publiées, les outils appliquent la même
 * règle, et ce module la calcule. Pâques d'abord, dont dépendent le lundi de
 * Pâques, l'Ascension et le lundi de Pentecôte, puis les huit fêtes fixes.
 *
 * Toutes les dates sont des dates UTC à midi : aucun fuseau ne les fait
 * glisser d'un jour.
 */

/** Une date sans heure, à midi UTC. */
export function jourUtc(annee, mois, date) {
    return new Date(Date.UTC(annee, mois, date, 12));
}

export function iso(date) {
    return date.toISOString().slice(0, 10);
}

export function ajouterJours(date, nombre) {
    const d = new Date(date);
    d.setUTCDate(d.getUTCDate() + nombre);
    return d;
}

/** Le dimanche de Pâques (algorithme de Meeus, calendrier grégorien). */
export function paques(annee) {
    const a = annee % 19;
    const b = Math.floor(annee / 100);
    const c = annee % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const mois = Math.floor((h + l - 7 * m + 114) / 31);
    const jour = ((h + l - 7 * m + 114) % 31) + 1;
    return jourUtc(annee, mois - 1, jour);
}

/** Les onze jours fériés de l'année, en ISO. */
export function joursFeries(annee) {
    const p = paques(annee);
    return new Set(
        [
            jourUtc(annee, 0, 1),
            ajouterJours(p, 1), // lundi de Pâques
            jourUtc(annee, 4, 1),
            jourUtc(annee, 4, 8),
            ajouterJours(p, 39), // Ascension
            ajouterJours(p, 50), // lundi de Pentecôte
            jourUtc(annee, 6, 14),
            jourUtc(annee, 7, 15),
            jourUtc(annee, 10, 1),
            jourUtc(annee, 10, 11),
            jourUtc(annee, 11, 25),
        ].map(iso),
    );
}

/** Un jour ouvré : ni samedi, ni dimanche, ni férié. */
export function estOuvre(date) {
    const jour = date.getUTCDay();
    if (jour === 0 || jour === 6) return false;
    return !joursFeries(date.getUTCFullYear()).has(iso(date));
}

/** Le jour même s'il est ouvré, sinon le premier jour ouvré qui suit. */
export function ouvreOuSuivant(date) {
    let d = new Date(date);
    while (!estOuvre(d)) d = ajouterJours(d, 1);
    return d;
}

/** Le n-ième jour ouvré APRÈS une date (la date elle-même ne compte pas). */
export function nemeJourOuvreApres(date, n) {
    let d = new Date(date);
    let compte = 0;
    while (compte < n) {
        d = ajouterJours(d, 1);
        if (estOuvre(d)) compte++;
    }
    return d;
}
